module.exports = __webpack_public_path__ + "img/banner-magang.85772b1b.jpg";